import React, { useState, useEffect } from "react"
import { withMicrocopy } from "~contexts/MicrocopyContext"
import CardList from "./CardList/CardList.component"
import Dropdown from "./Dropdown/Dropdown.component"
import "./index.scss"
import codeSamples from "./sample-code.json"
import codeSamplesJa from "./sample-code-ja.json"

const SampleCodeCatalog = ({ microcopy }) => {
  const labels = microcopy.text("sample_code_catalog.labels")
  const languages = [
    { value: "Universal", label: labels?.languages?.universal ? labels?.languages?.universal : "" },
    { value: "Android", label: labels?.languages?.android ? labels?.languages?.android : "" },
    { value: "Angular", label: labels?.languages?.angular ? labels?.languages?.angular : "" },
    { value: "AngularJS", label: labels?.languages?.angularjs ? labels?.languages?.angularjs : "" },
    { value: "APEX", label: labels?.languages?.apex ? labels?.languages?.apex : "" },
    { value: "cURL", label: labels?.languages?.curl ? labels?.languages?.curl : "" },
    { value: "Java", label: labels?.languages?.java ? labels?.languages?.java : "" },
    { value: "JavaScript", label: labels?.languages?.javascript ? labels?.languages?.javascript : "" },
    { value: "Node", label: labels?.languages?.node ? labels?.languages?.node : "" },
    { value: "Perl", label: labels?.languages?.perl ? labels?.languages?.perl : "" },
    { value: "PHP", label: labels?.languages?.php ? labels?.languages?.php : "" },
    { value: "PowerShell", label: labels?.languages?.powershell ? labels?.languages?.powershell : "" },
    { value: "Python", label: labels?.languages?.python ? labels?.languages?.python : "" },
    { value: "R", label: labels?.languages?.r ? labels?.languages?.r : "" },
    { value: "React", label: labels?.languages?.react ? labels?.languages?.react : "" },
    { value: "Ruby", label: labels?.languages?.ruby ? labels?.languages?.ruby : "" },
    { value: "Swift", label: labels?.languages?.swift ? labels?.languages?.swift : "" },
    { value: ".NET", label: labels?.languages?.dotNet ? labels?.languages?.dotNet : "" },
    { value: "TypeScript", label: labels?.languages?.ts ? labels?.languages?.ts : "" },
    { value: "Vue.js", label: labels?.languages?.vue ? labels?.languages?.vue : "" },
  ]

  const tags = [
    { value: "API", label: labels?.tags?.api ? labels?.tags?.api : "" },
    { value: "CLI", label: labels?.tags?.cli ? labels?.tags?.cli : "" },
    { value: "Frontend", label: labels?.tags?.frontend ? labels?.tags?.frontend : "" },
    { value: "Mobile", label: labels?.tags?.mobile ? labels?.tags?.mobile : "" },
    { value: "Provisioning", label: labels?.tags?.provisioning ? labels?.tags?.provisioning : "" },
    { value: "Salesforce", label: labels?.tags?.salesforce ? labels?.tags?.salesforce : "" },
    { value: "SDK", label: labels?.tags?.sdk ? labels?.tags?.sdk : "" },
    { value: "Skills", label: labels?.tags?.skills ? labels?.tags?.skills : "" },
    { value: "UI Elements", label: labels?.tags?.ui_elements ? labels?.tags?.ui_elements : "" },
    { value: "Webhooks", label: labels?.tags?.webhooks ? labels?.tags?.webhooks : "" },
  ]

  const [langFilter, setLangFilter] = useState([])
  const [tagFilter, setTagFilter] = useState([])
  const [samples, setSamples] = useState([])
  const [filteredSamples, setFilteredSamples] = useState(samples)

  useEffect(() => {
    if (microcopy.code === "ja") {
      setSamples(codeSamplesJa)
    } else {
      setSamples(codeSamples)
    }
  }, [])

  useEffect(() => {
    let newFilteredSamples
    if (langFilter.length === 0 && tagFilter.length === 0) {
      newFilteredSamples = samples
    } else {
      newFilteredSamples = samples.filter((sample) => (
        langFilter.length >= 1
          ? includesValuesFromArray(langFilter, sample.language) || langFilter.includes(sample.name)
          : samples))

      newFilteredSamples = newFilteredSamples.filter((sample) => (
        tagFilter.length >= 1
          ? includesValuesFromArray(tagFilter, sample.tags) || tagFilter.includes(sample.name)
          : newFilteredSamples))
    }
    setFilteredSamples(newFilteredSamples)
  }, [samples, langFilter, tagFilter])

  const includesValuesFromArray = (arr, values) => values.some((value) => arr.indexOf(value) !== -1)

  const onLangFilterChange = (value) => {
    let newFilter
    if (langFilter.some((item) => item === value[0].value)) {
      newFilter = langFilter.filter((e) => e !== value[0].value)
      setLangFilter(newFilter)
    } else {
      newFilter = value.map((item) => item.value)
      setLangFilter((langFilter) => langFilter.concat(newFilter))
    }
  }

  const onTagFilterChange = (value) => {
    let newFilter
    if (tagFilter.some((item) => item === value[0].value)) {
      newFilter = tagFilter.filter((e) => e !== value[0].value)
      setTagFilter(newFilter)
    } else {
      newFilter = value.map((item) => item.value)
      setTagFilter((tagFilter) => tagFilter.concat(newFilter))
    }
  }

  const resetFilters = () => {
    setTagFilter([])
    setLangFilter([])
  }

  return (
    <div className="sample-code">
      <h1 className="sample-code_title">
        {microcopy.text("sample_code_catalog.title")}
      </h1>
      <div className="sample-code_filters">
        <Dropdown
          className="sample-code_filter"
          isMulti
          hasFeaturedFirstItem
          microcopy={microcopy}
          placeHolder={microcopy.text("sample_code_catalog.labels.languages.all_languages")}
          options={languages}
          onChange={(value) => onLangFilterChange(value)}
          selectedValue={langFilter}
        />
        <Dropdown
          className="sample-code_filter"
          isMulti
          microcopy={microcopy}
          placeHolder={microcopy.text("sample_code_catalog.labels.tags.all_tags")}
          options={tags}
          onChange={(value) => onTagFilterChange(value)}
          selectedValue={tagFilter}
        />
        <button
          className="sample-code_reset-filters"
          onClick={() => resetFilters()}
        >
          {microcopy.text("sample_code_catalog.resetBtn")}
        </button>
      </div>
      <CardList className="sample-code_samples" samples={filteredSamples} />
    </div>
  )
}

export default withMicrocopy(SampleCodeCatalog)
